module.exports = __webpack_public_path__ + "img/icon_volunteering.d7ff41d.svg";